import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Services")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Robonomics contains a complete set of tools for developing IoT applications, both on the robotics and the user interface sides. Communication between the user and device happens using the most successful technologies from the Web3 world – IPFS, Ethereum, and Polkadot. Thus, developers can create modern and secure applications for Smart Cities and Industry 4.0. ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Learn more")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Recieve and decrypt the telemetry from your smart home IoT devices ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Set the colour of your smart lamp with your Robonomics Subscription - a Decentralized IoT cloud alternative. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Register a HomeAssistant account and start using the Robonomics Parachain with your IoT devices. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" The Sensors Robonomics Network is a civilian network of sensors to monitor air quality. Anyone can build their own sensor or use an off-the-shelf solution from the development team and set it up in their home. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Learn and practice with the Boston Dynamics Spot robot wherever you are. After each lesson you will receive a captured video of the robot movements and a printable PDF certificate. ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Connect to an autonomous telescope in the dark night of the Atacama desert in Chile to capture an astronomical object and mint unique NFTs in a few clicks. ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Carbon footprint clearance for smart buildings based on geolocation and energy consumption information. ")

export function render(_ctx, _cache) {
  const _component_robo_card_label_section = _resolveComponent("robo-card-label-section")
  const _component_robo_link = _resolveComponent("robo-link")
  const _component_robo_card_label = _resolveComponent("robo-card-label")
  const _component_robo_template_services_item = _resolveComponent("robo-template-services-item")
  const _component_robo_grid = _resolveComponent("robo-grid")
  const _component_robo_card_section = _resolveComponent("robo-card-section")
  const _component_robo_card = _resolveComponent("robo-card")
  const _component_robo_grid_item = _resolveComponent("robo-grid-item")

  return (_openBlock(), _createBlock(_component_robo_grid_item, null, {
    default: _withCtx(() => [
      _createVNode(_component_robo_card, { allowExpand: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_robo_card_label, null, {
            default: _withCtx(() => [
              _createVNode(_component_robo_card_label_section, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_robo_card_label_section, { info: "" }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createVNode(_component_robo_link, { href: "https://robonomics.network/" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_robo_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_robo_grid, {
                columnsRepeat: "3",
                offset: "x0",
                mediaMobile: "transfer"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_robo_template_services_item, {
                    router: { name: 'smarthome-telemetry' },
                    label: "academy",
                    picture: "./images/services-telemetry.jpg",
                    providers: [
              {
                name: 'Robonomics Core Team',
                link: 'https://robonomics.network'
              }
            ],
                    title: "SmartHome Telemetry"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["providers"]),
                  _createVNode(_component_robo_template_services_item, {
                    router: "/lights-up",
                    label: "academy",
                    picture: "./images/services-lights-up.jpg",
                    providers: [
              {
                name: 'Robonomics Core Team',
                link: 'https://robonomics.network'
              }
            ],
                    title: "Lights Up"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["providers"]),
                  _createVNode(_component_robo_template_services_item, {
                    router: { name: 'home-assistant-account' },
                    picture: "./images/services-ha.jpg",
                    providers: [
              {
                name: 'Robonomics Core Team',
                link: 'https://robonomics.network'
              }
            ],
                    title: "HomeAssistant Account"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["providers"]),
                  _createVNode(_component_robo_template_services_item, {
                    href: "https://sensors.robonomics.network/#/",
                    picture: "./images/services-sensors.jpg",
                    providers: [
              {
                name: 'Robonomics Core Team',
                link: 'https://robonomics.network'
              },
              {
                name: 'Airalab Rus',
                link: 'https://airalab.org/en/'
              }
            ],
                    title: "Decentralized Sensor Map"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["providers"]),
                  _createVNode(_component_robo_template_services_item, {
                    href: "https://dapp.spot-sdk.education/#/",
                    picture: "./images/services-spot.jpg",
                    providers: [
              {
                name: 'Robonomics Core Team',
                link: 'https://robonomics.network'
              },
              {
                name: 'Merklebot',
                link: 'https://merklebot.com'
              }
            ],
                    title: "Boston Dynamics Spot SDK lessons"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["providers"]),
                  _createVNode(_component_robo_template_services_item, {
                    href: "https://telescope.merklebot.com/#/",
                    picture: "./images/services-telescope.jpg",
                    providers: [
              {
                name: 'Robonomics Core Team',
                link: 'https://robonomics.network'
              },
              {
                name: 'Merklebot',
                link: 'https://merklebot.com'
              }
            ],
                    title: "An Autonomous Telescope Minting RMRK NFT's"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["providers"]),
                  _createVNode(_component_robo_template_services_item, {
                    href: "https://dapp.ipci.io/#/offsetting",
                    picture: "./images/services-offsetting.jpg",
                    providers: [
              {
                name: 'Robonomics Core Team',
                link: 'https://robonomics.network'
              },
              {
                name: 'DAO IPCI',
                link: 'https://ipci.io/'
              },
              {
                name: 'Evercity',
                link: 'https://www.evercity.io/'
              }
            ],
                    title: "Smart Building Offsetting"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["providers"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}